const MOBILE = "MOBILE";
const DESKTOP = "DESKTOP";
const hairGrowingSection = document.querySelector(".sr-hair-growing");
const allBlocks = hairGrowingSection.querySelectorAll(".hair-container");
const desktopLashes = hairGrowingSection.querySelectorAll(".lash-desktop");
const mobileLashes = hairGrowingSection.querySelectorAll(".lash-mobile");
const textBlocks = document.querySelectorAll(".content-container__block");

const lashRect = hairGrowingSection.getBoundingClientRect();
const lashesGrowingSectionHeight = lashRect.bottom - lashRect.top;

// type can be MOBILE or DESKTOP only, depending on what device we are, we transform X and Y
function growLashes(lash, percentage, type) {
  if (type === "DESKTOP")
    lash.style.transform = `translateY(${100 - percentage}%)`;
  if (type === "MOBILE") {
    lash.style.transform = `translateY(${100 - percentage}%)`;
  }
}

function showBlocksMobile(block, scrollProgress, scrollPercetageTrigger, type) {
  if (scrollProgress >= scrollPercetageTrigger) {
    block.classList.add(`content-container__block--visible`);
  } else {
    block.classList.remove(`content-container__block--visible`);
  }
}

function handleScroll() {
  // Get scroll position relative to hairGrowingSection
  const rect = hairGrowingSection.getBoundingClientRect();
  // Calculate scroll progress as a percentage of section height
  // * 100 converts to percentage
  // * 1.2 (number after 100 controls the speed on the scroll percentage)
  // - 0 (delays animation by that number % of sections height)
  const scrollProgressDesktop =
    100 - (rect.top / lashesGrowingSectionHeight) * 100 * 1.8 + 30;
  const scrollProgressMobile =
    100 - (rect.top / lashesGrowingSectionHeight) * 100 * 1 - 10;

  if (scrollProgressDesktop < 100) {
    if (window.innerWidth > 768) {
      showBlocksMobile(textBlocks[0], scrollProgressDesktop, 20, DESKTOP);
      showBlocksMobile(textBlocks[1], scrollProgressDesktop, 50, DESKTOP);
      showBlocksMobile(textBlocks[2], scrollProgressDesktop, 80, DESKTOP);
      desktopLashes.forEach((lash) => {
        growLashes(lash, scrollProgressDesktop, DESKTOP);
      });
    }
  }

  if (scrollProgressMobile < 100) {
    if (window.innerWidth < 768) {
      showBlocksMobile(textBlocks[0], scrollProgressMobile, 20, MOBILE);
      showBlocksMobile(textBlocks[1], scrollProgressMobile, 50, MOBILE);
      showBlocksMobile(textBlocks[2], scrollProgressMobile, 80, MOBILE);
      desktopLashes.forEach((lash) =>
        growLashes(lash, scrollProgressMobile, MOBILE)
      );
    }
  }
  // Divide hairGrowingSection into four parts based on scroll progress
}
// Function to handle intersection changes
function handleIntersection(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      window.addEventListener("scroll", handleScroll);
    } else {
      window.removeEventListener("scroll", handleScroll);
    }
  });
}

// Options for the Intersection Observer
const options = {
  root: null, // Use the viewport as the root
  rootMargin: "0px", // No margin around the root
  threshold: 0.5, // Trigger callback when 50% of hairGrowingSection is visible
};

// Create Intersection Observer instance
const observer = new IntersectionObserver(handleIntersection, options);

// Start observing hairGrowingSection
observer.observe(hairGrowingSection);
